import { H2, P } from "../../components"
import { formatDate } from "../../utils/formatDate"
import Anchor from "../anchor/anchor"

const PostPreview = ({
	title,
	slug,
	author,
	date,
	excerpt,
	featuredImage,
	style,
}) => {
	return (
		<Anchor href={`/blog/${slug}`} className="space-y-2" style={style}>
			{featuredImage && (
				<img
					style={{ width: "100%" }}
					src={featuredImage.node.sourceUrl}
					alt=""
				/>
			)}
			<div className="flex flex-row items-center">
				<P>{author}</P>
				&nbsp;|&nbsp;
				<P>{formatDate(date)}</P>
			</div>
			<H2>{title}</H2>
			<div dangerouslySetInnerHTML={{ __html: excerpt }} />
		</Anchor>
	)
}

export default PostPreview
